module.exports = [
  {
    key: 'PUSH',
    label: {
      en: 'Push',
      es: '',
    },
  },
  {
    key: 'INFUSION',
    label: {
      en: 'Infusion',
      es: '',
    },
  },
];
